// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__16aGk","inputWrap":"Table_inputWrap__3v3p_","col":"Table_col__2Zs3s","bmiTooltip":"Table_bmiTooltip__2Y-Be"};